/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, {useEffect, useMemo, useState} from 'react'
//components
//constants
import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../../_metronic/helpers'
import {getUserData} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import moment from 'moment'
import {FrontendDashboardMsgInbound} from './FrontEndDashboardSlice/FrontendDashboardSlice'
import ReactApexChart from 'react-apexcharts'
import QuickMessageDrawerInner from '../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {useNavigate} from 'react-router-dom'
import {WSSelect} from '../../../../_metronic/helpers/components/WSSelect/WSSelect'
import NodataYet from '../../../Components/NodataYet'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import Spinner from '../../../Components/Spinner'
import {get} from 'lodash'
import {
  useGetDashboardActivityOverviewGraphQuery,
  useGetDashboardEngagementAndRetentionGraphQuery,
  useGetDashboardRecentInboundMessagesQuery,
  useGetDashboardMessageSentVsCreditCostQuery,
  useGetDashboardQMAndAPIStatisticQuery,
} from '../../../../services/cellcast'
import {FixedTwoDecimal} from '../../../Utils/_helpers/string'
import {
  getAllUserDetails,
  getIsDefaultRegion,
  getDefaultRegion,
} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useLazyGetSubClientRemainingCreditQuery} from '../../../../services/cellcast.v2'
import {GetSubClientShareCreditMode} from '../../../../services/cellcast.v2.types'
import {toast} from 'react-toastify'
import ProgressCard from '../../../Components/ProgressCard'
import LineChartCard from '../../../Components/LineChartCard'
import {useGetReportLineChartsQuery, useGetReportListQuery} from '../../../../services/cellcast.v3'
import {REGION} from '../../../Utils/Constant/ConstantForWebsite'
import WSButton from '../../../../_metronic/helpers/components/WSButton/WSButton'
import {Button} from 'react-bootstrap'
import useResponsive from '../../../hooks/useResponsive'

const ChartDashboard = ({
  FELeadGraph,
  FELeadGraphUs,
  whereWhen,
  FEDashboardState,
  FEDashboardGraph,
  FEDashboardStateUs,
}: any) => {
  const navigate = useNavigate()
  const userData: any = useSelector(getAllUserDetails)
  const {isMobile} = useResponsive()
  const [isShowCredit, setIsShowCredit] = useState(true)
  const [isSetCreditLimit, setIsShareCreditLimit] = useState(false)
  const [shareCreditRemain, setShareCreditRemain] = useState({
    type: '',
    sms: '-',
    mms: '-',
  })
  const [getRemainCredit] = useLazyGetSubClientRemainingCreditQuery()
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const userRegion = useSelector(getDefaultRegion)

  const [quickMessage, setQuickmessage] = useState(false)
  const [campType, setCampType] = useState('sms')
  const [campTypeinbound, setCampTypeInbound] = useState('sms')
  const [campTypeQMvsAPI, setCampTypeQMvsAPI] = useState('sms')
  const [campTypeCreditCost, setCampTypeCreditCost] = useState('sms')
  const [contact, setContact] = useState()
  const user = useSelector(getUserData)
  const dispatch = useDispatch()

  const FEActivity: any = useGetDashboardActivityOverviewGraphQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      camp_type: campType,
    },
    {
      skip: !isDefaultRegion,
    }
  )

  const FEEngagementAndRetention: any = useGetDashboardEngagementAndRetentionGraphQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
    },
    {
      skip: !isDefaultRegion,
    }
  )

  const FEInbound = useGetDashboardRecentInboundMessagesQuery(
    {
      camp_type: campType,
    },
    {
      skip: !isDefaultRegion,
    }
  )

  const FEMessageSentVsCreditCost: any = useGetDashboardMessageSentVsCreditCostQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      camp_type: campTypeCreditCost,
    },
    {
      skip: !isDefaultRegion,
    }
  )

  const FEQMAndAPIStatistic: any = useGetDashboardQMAndAPIStatisticQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      camp_type: campTypeQMvsAPI,
    },
    {
      skip: !isDefaultRegion,
    }
  )

  const FEInboundUs = useGetReportListQuery(
    {
      campType: campTypeinbound,
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      limit: 5,
      page: 1,
      scope: 'inbound',
      type: 'message',
    },
    {
      skip: isDefaultRegion,
    }
  )

  const clickThroughData = useGetReportLineChartsQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      campType: campType,
      scope: 'click-through',
      type: 'message',
    },
    {
      skip: isDefaultRegion,
    }
  )

  const repliesData = useGetReportLineChartsQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      campType: campType,
      scope: 'reply',
      type: 'message',
    },
    {
      skip: isDefaultRegion,
    }
  )

  const deliveredMessageData = useGetReportLineChartsQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      campType: campType,
      scope: 'delivered',
      type: 'message',
    },
    {
      skip: isDefaultRegion,
    }
  )

  const inboundMessageData = useGetReportLineChartsQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      campType: campType,
      scope: 'inbound',
      type: 'message',
    },
    {
      skip: isDefaultRegion,
    }
  )

  const unsubscribeContactData = useGetReportLineChartsQuery(
    {
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      scope: 'unsubscribe',
      type: 'contact',
    },
    {
      skip: isDefaultRegion,
    }
  )

  const credits = useSelector((state: any) => state?.userDetails?.userDetails?.data)

  const mapChartData = (item = []) => {
    return item?.length > 0
      ? item?.map((key: any) => [+moment.utc(key?._id).format('x'), key?.count])
      : []
  }

  const retentionDatamanually =
    FEEngagementAndRetention?.data?.data?.graph?.unsub?.map((key: any) => key?.count) || []

  const unsubscribeContacts =
    unsubscribeContactData?.data?.data?.items?.map((key) => key?.count) || []

  const leadGenrationMonth =
    moment(whereWhen?.end).diff(moment(whereWhen?.start), 'days') > 30
      ? FELeadGraph?.data?.data?.leadsGraphData?.map((key: any) => moment(key?._id).format('MMM'))
      : FELeadGraph?.data?.data?.leadsGraphData?.map((key: any, index: number) =>
          index == 0 || index == FELeadGraph?.data?.leadsGraphData?.length - 1
            ? moment(key?._id).format('MMM')
            : ''
        ) || []

  const retentionGenrationMonth =
    moment(whereWhen?.end).diff(moment(whereWhen?.start), 'days') > 30
      ? FEEngagementAndRetention?.data?.data?.graph?.unsub?.map((key: any) =>
          moment(key?._id).format('MMM')
        )
      : FEEngagementAndRetention?.data?.data?.retentionData?.map((key: any, index: number) =>
          index == 0 || index == FEDashboardGraph?.data?.data?.graph?.unsub?.length - 1
            ? moment(key?._id).format('MMM')
            : ''
        ) || []
  const retentionGenrationMonthUs =
    moment(whereWhen?.end).diff(moment(whereWhen?.start), 'days') > 30
      ? unsubscribeContactData?.data?.data?.items?.map((key: any) => moment(key?._id).format('MMM'))
      : unsubscribeContactData?.data?.data?.items?.map((key: any, index: number) =>
          index == 0 || index == (unsubscribeContactData?.data?.data?.items?.length as number) - 1
            ? moment(key?._id).format('MMM')
            : ''
        ) || []

  const FEActivityData = get(FEActivity, 'data.data.[0]')

  const deliveredMessageCountData = mapChartData(FEActivityData?.deliveredMessageCount)
  const deliveredMessageCountDataUs = mapChartData(deliveredMessageData?.data?.data?.items as any)

  const inboundMessageCountData = mapChartData(FEActivityData?.inboundMessageCount)
  const inboundMessageCountDataUs = mapChartData(inboundMessageData?.data?.data?.items as any)

  const FEEngagementAndRetentionData = get(FEEngagementAndRetention, 'data.data.graph')
  const leadDatamanually = mapChartData(FELeadGraph?.data?.data?.leadsGraphData)
  const leadDatamanuallyUs = mapChartData(FELeadGraphUs?.data?.data?.items)
  const clickThroughCountData = mapChartData(FEEngagementAndRetentionData?.clickThrough)
  const repliesCountData = mapChartData(FEEngagementAndRetentionData?.replies)
  const repliesCountDataUs = mapChartData(repliesData?.data?.data?.items as any)
  const clickThroughCountDataUs = mapChartData(clickThroughData?.data?.data?.items as any)
  const replysMessageCountData = mapChartData(FEActivityData?.replysMessageCount)
  const replysMessageCountDataUs = mapChartData(repliesData?.data?.data?.items as any)
  const rejectedMessageCountData = mapChartData(FEActivityData?.rejectedMessageCount)
  const failedMessageCountData = mapChartData(FEActivityData?.failedMessageCount)
  const unsubChartData = mapChartData(FEEngagementAndRetentionData?.unsub)

  // Message Sent vs Credit Cost data
  const FEMessageSentVsCreditCostData = get(FEMessageSentVsCreditCost, 'data.data.[0]')
  const messageSentCountData =
    FEMessageSentVsCreditCostData?.messageSentCount?.length > 0
      ? FEMessageSentVsCreditCostData?.messageSentCount?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []

  const creditCostData =
    FEMessageSentVsCreditCostData?.creditCost?.length > 0
      ? FEMessageSentVsCreditCostData?.creditCost?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []

  const messagePartsData =
    FEMessageSentVsCreditCostData?.messageParts?.length > 0
      ? FEMessageSentVsCreditCostData?.messageParts?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []

  // QM vs API Statistic data
  const FEQMAndAPIStatisticData = get(FEQMAndAPIStatistic, 'data.data.[0]')
  const qmMessageCountData = mapChartData(FEQMAndAPIStatisticData?.qmMessageCount)
  const apiMessageCountData = mapChartData(FEQMAndAPIStatisticData?.apiMessageCount)

  const qmAndAPIStatisticChart: any = {
    series: [
      {
        name: 'Quick Message',
        data: qmMessageCountData,
      },
      {
        name: 'API',
        data: apiMessageCountData,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
          autoSelected: 'zoom',
        },
      },
      colors: ['#009ef7', '#50cd89'],
      noData: {
        text: 'No data yet',
        align: 'center',
        verticalAlign: 'middle',
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
      },
    },
  }

  const messageSentVsCreditCostChart: any = {
    series: [
      {
        name: 'Messages Sent',
        data: messageSentCountData,
      },
      {
        name: 'Credit Usage',
        data: creditCostData,
      },
      {
        name: 'Message Parts',
        data: messagePartsData,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
          autoSelected: 'zoom',
        },
      },
      colors: ['#009ef7', '#f1416c', '#50cd89'],
      noData: {
        text: 'No data yet',
        align: 'center',
        verticalAlign: 'middle',
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function(val: any, opts: any) {
            return val?.toFixed(0)
          },
        },
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
      },
    },
  }

  const LeadsData: any = {
    series: [
      {
        name: 'New lead',
        data: isDefaultRegion ? leadDatamanually : leadDatamanuallyUs,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        toolbar: {
          show: false,
          autoSelected: 'zoom',
        },
      },
      noData: {
        text: 'No data yet',
        offsetY: -20,
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },

      yaxis: {
        labels: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },

      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      stroke: {
        width: 4,
        curve: 'smooth',
      },
    },
  }

  const EngagementData: any = {
    series: [
      {
        name: 'Replies',
        data: isDefaultRegion ? repliesCountData : repliesCountDataUs,
      },
      {
        name: 'Click links',
        data: isDefaultRegion ? clickThroughCountData : clickThroughCountDataUs,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
          autoSelected: 'zoom',
        },
      },
      noData: {
        text: 'No data yet',
        offsetY: -20,
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },

      yaxis: {
        labels: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },

      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      stroke: {
        width: 4,
        curve: 'smooth',
      },
    },
  }

  const ReviewsData: any = {
    series: [
      {
        name: 'Reviews',
        type: 'area',
        data: [],
      },
    ],
    options: {
      chart: {
        type: 'area',
        height: 350,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      colors: ['#FCC419'],
      noData: {
        text: 'Coming Soon',
        offsetY: -20,
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: leadGenrationMonth,
        labels: {
          show: true,
        },
      },

      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          type: 'vertical',
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      stroke: {
        width: 4,
        curve: 'smooth',
      },
    },
  }

  const RetentionData: any = {
    series: [
      {
        name: 'Retention',
        type: 'area',
        data: isDefaultRegion ? unsubChartData : unsubscribeContacts,
      },
    ],
    options: {
      chart: {
        type: 'area',
        height: 350,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      colors: ['#EF3A3A'],
      noData: {
        text: 'No data yet',
        offsetY: -20,
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: isDefaultRegion
        ? {
            type: 'datetime',
          }
        : {
            categories: retentionGenrationMonthUs,
            labels: {
              show: true,
            },
          },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          type: 'vertical',
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      stroke: {
        width: 4,
        curve: 'smooth',
      },
    },
  }

  const activity: any = {
    series: [
      {
        name: `Delivered`,
        data: isDefaultRegion ? deliveredMessageCountData : deliveredMessageCountDataUs,
      },
      {
        name: `Inbound`,
        data: isDefaultRegion ? inboundMessageCountData : inboundMessageCountDataUs,
      },
      {
        name: `Replys`,
        data: isDefaultRegion ? replysMessageCountData : replysMessageCountDataUs,
      },
      ...(isDefaultRegion
        ? [
            {
              name: `Rejected`,
              data: rejectedMessageCountData,
            },
            {
              name: `Failed`,
              data: failedMessageCountData,
            },
          ]
        : []),
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
          autoSelected: 'zoom',
        },
      },
      colors: isDefaultRegion ? ['#009ef7', '#50cd89', '#7239ea', '#ffc700', '#f1416c'] : undefined,
      noData: {
        text: 'No data yet',
        align: 'center',
        verticalAlign: 'middle',
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
      },
    },
  }

  const sendQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        show={quickMessage}
        handleClose={() => setQuickmessage(false)}
        contacts={[{value: contact, label: contact}]}
      />
    ),
    [quickMessage]
  )
  useEffect(() => {
    dispatch(
      FrontendDashboardMsgInbound({
        camp_type: campTypeinbound,
      })
    )
  }, [campTypeinbound])

  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsShowCredit(false)
        if (userData.subClientLimitConfig) {
          if (
            userData.subClientLimitConfig.smsLimitPerDay > 0 ||
            userData.subClientLimitConfig.mmsLimitPerDay > 0 ||
            userData.subClientLimitConfig.smsLimitPerMonth > 0 ||
            userData.subClientLimitConfig.mmsLimitPerMonth > 0
          ) {
            setIsShareCreditLimit(true)
          }
        }
      }
    }
  }, [userData])

  useEffect(() => {
    if (isSetCreditLimit === true) {
      getRemainCredit(null)
        .then((res) => {
          if ('data' in res) {
            if (res.data && res.data.data) {
              setShareCreditRemain({
                type: res.data.data.mode === GetSubClientShareCreditMode.Day ? `Day` : 'Month',
                sms: res.data.data.credit.sms.toString(),
                mms: res.data.data.credit.mms.toString(),
              })
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            if (errObj.data.message) {
              toast.error(errObj.data.message)
            } else {
              toast.error(res.error)
            }
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    }
  }, [isSetCreditLimit])

  let typeOption: any = [
    {value: 'sms', label: 'SMS'},
    // TODO: enabled again after MMS been fixed
    {value: 'mms', label: 'MMS'},
  ]

  return (
    <>
      {AuthenticateUser('send-quick-sms') && quickMessage && sendQuickMessage}
      <div className='d-flex flex-row card-number-div-wrapper'>
        <div className='card mt-5 w-200px px-10 py-10 bg-black'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 text-white'>
              Welcome, {user?.user?.name}!
            </span>
          </h3>

          {/* <span className='text-white new-video mt-4'>New Video</span>
          <span className='text-white mt-2'>
            Watch setup
            <br /> video tutorial{' '}
            <KTSVG path='/media/icons/duotune/arrows/arr071.svg' className='svg-icon-2' />
          </span> */}
        </div>

        <div className='card mt-5 w-163px px-10 py-10 align-items-start justify-content-between'>
          <div className='d-flex justify-content-between'>
            <a
              className={'badge green_text_badge badge-square me-2 p-4 w-50px h-40px '}
              style={{
                fontSize: '14px',
              }}
            >
              SMS
            </a>
            {isShowCredit && (
              <>
                {credits?.credits?.sms > 100 ? null : (
                  <a
                    href=''
                    onClick={() => navigate('/topup')}
                    className={'badge badge-light-danger topupBtn  me-2 p-4 h-10px fs-9'}
                  >
                    Top up
                  </a>
                )}
              </>
            )}
          </div>
          <div>
            <h3 className='card-title align-items-start flex-column mt-0 pt-3'>
              <span className='card-label fw-bolder fs-2'>
                {isShowCredit
                  ? `${FixedTwoDecimal(credits?.credits?.sms || 0)}`
                  : `${shareCreditRemain.sms}`}
              </span>
            </h3>
            <div className='text-muted fs-7'>
              SMS Credits {shareCreditRemain.type !== '' && `Per ${shareCreditRemain.type}`}
            </div>
            <div
              className='badge top badge-light-success fw-bold d-flex align-items-center gap-1 invisible'
              style={{
                width: 'fit-content',
                marginTop: '25px',
              }}
            >
              <span className='arrow'>
                <KTSVG path='/media/misc/arrow-up.svg' />
              </span>
              4.5%
            </div>
          </div>
        </div>
        <div className='card mt-5 w-163px px-10 py-10 align-items-start justify-content-between'>
          <div className='d-flex justify-content-between'>
            <a
              className={'badge blue_text_badge badge-square me-2 p-4 w-50px h-40px '}
              style={{
                fontSize: '14px',
              }}
            >
              MMS
            </a>
            {isShowCredit && (
              <>
                {credits?.credits?.mms > 100 ? null : (
                  <a
                    href=''
                    onClick={() => navigate('/topup')}
                    className={'badge badge-light-danger topupBtn  me-2 p-4 h-10px fs-9'}
                  >
                    Top up
                  </a>
                )}
              </>
            )}
          </div>
          <div>
            {isDefaultRegion || [REGION.US, REGION.UK].includes(userRegion) ? (
              <h3 className='card-title align-items-start flex-column mt-0 pt-3'>
                <span className={`card-label fw-bolder fs-2`}>
                  {isShowCredit
                    ? `${FixedTwoDecimal(credits?.credits?.mms || 0)}`
                    : `${shareCreditRemain.mms}`}
                </span>
              </h3>
            ) : (
              <span className='card-label fw-bolder fs-2 text-muted'>Not Supported</span>
            )}
            <div
              className={`text-muted fs-7 ${!isDefaultRegion &&
                ![REGION.US, REGION.UK].includes(userRegion) &&
                'd-none'}`}
            >
              MMS Credits {shareCreditRemain.type !== '' && `Per ${shareCreditRemain.type}`}
            </div>
            <div
              className='badge top badge-light-danger fw-bold d-flex align-items-center gap-1 invisible'
              style={{
                width: 'fit-content',
                marginTop: '25px',
              }}
            >
              <span className='arrow'>
                <KTSVG path='/media/misc/arrow-down.svg' />
              </span>
              2.5%
            </div>
          </div>
        </div>

        <div className={`progress-card-row ${isMobile ? 'progress-card-row--mobile' : ''}`}>
            <ProgressCard
              isLoading={isDefaultRegion ? FEDashboardState?.isLoading : FEDashboardStateUs?.isLoading}
              title="Hot Contacts"
              progressValue={
                isDefaultRegion
                  ? FEDashboardState?.data?.data?.hotContactcCount
                  : FEDashboardStateUs?.data?.data?.hotContactcCount
              }
              tooltipText="Click through more than 3 times"
              onClick={() => navigate('/report-analytics/short-link?scrollId=activity-log')}
              compact={isMobile}
            />

            <ProgressCard
              isLoading={isDefaultRegion ? FEDashboardState?.isLoading : FEDashboardStateUs?.isLoading}
              title="Warm Contacts"
              progressValue={
                isDefaultRegion
                  ? FEDashboardState?.data?.data?.warmContactCount
                  : FEDashboardStateUs?.data?.data?.warmContactcCount
              }
              tooltipText="Click through 1 - 2 times"
              onClick={() => navigate('/report-analytics/short-link?scrollId=activity-log')}
              compact={isMobile}
            />

            <ProgressCard
              isLoading={isDefaultRegion ? FEDashboardState?.isLoading : FEDashboardStateUs?.isLoading}
              title="Clickthrough (CTR)"
              progressValue={
                isDefaultRegion
                  ? FEDashboardState?.data?.data?.CTRCount
                  : FEDashboardStateUs?.data?.data?.CTRCount
              }
              tooltipText=""
              onClick={() => navigate('/report-analytics/short-link?scrollId=activity-log')}
              compact={isMobile}
            />
        </div>

        {/* </div> */}
      </div>

      <div className='d-flex flex-row dashboard_chart_row'>
        <LineChartCard
          whereWhen={whereWhen}
          seriesData={LeadsData}
          chartData={isDefaultRegion ? FELeadGraph : FELeadGraphUs}
          title='New Leads'
          toolTipText='Subscribers Contacts'
        />

        <LineChartCard
          whereWhen={whereWhen}
          seriesData={EngagementData}
          chartData={
            isDefaultRegion
              ? {
                  isLoading: FEEngagementAndRetention?.isLoading,
                  data: {
                    data: {
                      total:
                        (FEEngagementAndRetention?.data?.data?.total?.clickThrough || 0) +
                        (FEEngagementAndRetention?.data?.data?.total?.replies || 0),
                    },
                  },
                }
              : {
                  isLoading: repliesData?.isLoading,
                  data: {
                    data: {
                      total:
                        (repliesData?.data?.data?.total || 0) +
                        (clickThroughData?.data?.data?.total || 0),
                    },
                  },
                }
          }
          title='Engagement'
          toolTipText='Replies + Link clicks'
        />

        <LineChartCard
          whereWhen={whereWhen}
          title='Reviews'
          toolTipText='Google reviews'
          seriesData={ReviewsData}
        />

        <LineChartCard
          whereWhen={whereWhen}
          seriesData={RetentionData}
          chartData={
            isDefaultRegion
              ? {
                  data: {
                    data: {
                      total: FEEngagementAndRetention?.data?.data?.total?.unsub || 0,
                    },
                  },
                  isLoading: FEEngagementAndRetention?.isLoading,
                }
              : unsubscribeContactData
          }
          title='Retention'
          toolTipText='Unsubscribes Contacts'
        />
      </div>

      <div className='d-flex flex-row activity_inbound_row mobile-layout'>
        <div className='col-lg-8 py-6 h-460px'>
          <div className='card w-440px h-450px'>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-4 mb-1'>Activity overview</span>
                {/* <span className='text-muted fw-light fs-8'>Mos</span> */}
              </h3>
              <div className='card-toolbar'>
                <form
                  data-kt-search-element='form'
                  className='me-2 position-relative'
                  autoComplete='off'
                >
                  {/* <WSSelect placeholder='All campaigns' selectList={options} /> */}
                  <WSSelect
                    value={campType}
                    onChange={(e: any) => {
                      setCampType(e.value)
                    }}
                    placeholder='SMS'
                    options={
                      isDefaultRegion
                        ? typeOption
                        : typeOption?.filter((it: any) => it.value === 'sms')
                    }
                  />
                </form>
                {/* <WSButton type='button' className='btn btn-sm btn-icon btn-primary w-100px'>
                  View all
                </WSButton> */}
              </div>
            </div>
            {FEActivity?.isLoading ? (
              <Spinner />
            ) : activity?.series.length > 0 ? (
              <div className=''>
                <div className=''>
                  <ReactApexChart
                    options={activity.options}
                    series={activity.series}
                    type='area'
                    height={375}
                    width='100%'
                  />
                </div>
              </div>
            ) : (
              <NodataYet message={'No data yet'} customeHight='100' />
            )}
          </div>
        </div>

        <div className='col-lg-4'>
          <div
            className='d-flex flex-row recent-message-main-wrap mt-5'
            style={{borderRadius: '8px'}}
          >
            {isDefaultRegion ? (
              <div className='card mt-5 w-100  px-10 py-5'>
                <span className='r-title'>Recent inbound messages</span>
                <WSSelect
                  value={campTypeinbound}
                  onChange={(e: any) => setCampTypeInbound(e.value)}
                  placeholder='SMS'
                  options={typeOption.filter((it: any) => it.value === 'sms')}
                />
                <p className='grey-common-text mb'>Ordered by most recent</p>

                {FEInbound?.isLoading ? (
                  <Spinner />
                ) : FEInbound?.data?.data?.length > 0 ? (
                  <table className='inbound-message-table'>
                    <thead>
                      <th style={{color: '#A2A5B5', fontWeight: '500'}}>CONTACT</th>
                      <th style={{color: '#A2A5B5', fontWeight: '500'}}>MESSAGE</th>
                      <th style={{color: '#A2A5B5', fontWeight: '500', textAlign: 'right'}}>
                        ACTION
                      </th>
                    </thead>
                    <tbody>
                      {FEInbound?.data?.data?.map((key: any, i: number) => {
                        return (
                          <tr key={i}>
                            <td>
                              <b className='text-black'>
                                {key?.fields?.[0]?.find((key: any) => key?.name === 'First Name')
                                  ?.value || '--'}{' '}
                              </b>
                              <br />
                              {key?.mobile || '--'}
                            </td>
                            <td>{key?.customerResponse}</td>
                            <td style={{textAlign: 'right'}}>
                              {AuthenticateUser('send-quick-sms') && (
                                <KTSVG
                                  onClick={() => {
                                    setQuickmessage(true)
                                    setContact(key?.mobile)
                                  }}
                                  path={'/media/icons/duotune/navigationicon/messages.svg'}
                                  className='svg-icon-1x p-2 btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                />
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                ) : (
                  <NodataYet message={'No data yet'} />
                )}
              </div>
            ) : (
              <div className='card mt-5 w-100  px-10 py-5'>
                <span className='r-title'>Recent inbound messages</span>
                <WSSelect
                  value={campTypeinbound}
                  onChange={(e: any) => setCampTypeInbound(e.value)}
                  placeholder='SMS'
                  options={typeOption.filter((it: any) => it.value === 'sms')}
                />
                <p className='grey-common-text mb'>Ordered by most recent</p>

                {FEInboundUs?.isLoading ? (
                  <Spinner />
                ) : FEInboundUs?.data?.data?.items?.length > 0 ? (
                  <table className='inbound-message-table'>
                    <thead>
                      <th style={{color: '#A2A5B5', fontWeight: '500'}}>CONTACT</th>
                      <th style={{color: '#A2A5B5', fontWeight: '500'}}>MESSAGE</th>
                      <th style={{color: '#A2A5B5', fontWeight: '500', textAlign: 'right'}}>
                        ACTION
                      </th>
                    </thead>
                    <tbody>
                      {FEInboundUs?.data?.data?.items?.map((key: any, i: number) => {
                        return (
                          <tr key={i}>
                            <td>
                              <b className='text-black'>{key?.metadata?.sender_name || '--'}</b>
                              <br />
                              {key?.metadata?.sender || '--'}
                            </td>
                            <td>{key?.metadata?.message}</td>
                            <td style={{textAlign: 'right'}}>
                              {AuthenticateUser('send-quick-sms') && (
                                <KTSVG
                                  onClick={() => {
                                    setQuickmessage(true)
                                    setContact(key?.metadata?.sender)
                                  }}
                                  path={'/media/icons/duotune/navigationicon/messages.svg'}
                                  className='svg-icon-1x p-2 btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                />
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                ) : (
                  <NodataYet message={'No data yet'} />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {isDefaultRegion && (
        <div className='row mt-5'>
          <div className='col-lg-6'>
            <div className='card h-450px'>
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-4 mb-1'>Quick Message vs API</span>
                  <span className='text-muted fw-light fs-7'>Message distribution by source</span>
                </h3>
                <div className='card-toolbar'>
                  <form
                    data-kt-search-element='form'
                    className='me-2 position-relative'
                    autoComplete='off'
                  >
                    <WSSelect
                      value={campTypeQMvsAPI}
                      onChange={(e: any) => {
                        setCampTypeQMvsAPI(e.value)
                      }}
                      placeholder='SMS'
                      options={typeOption}
                    />
                  </form>
                </div>
              </div>
              <div className='card-body'>
                {FEQMAndAPIStatistic?.isLoading ? (
                  <div className='d-flex justify-content-center align-items-center h-350px'>
                    <Spinner />
                  </div>
                ) : (
                  <ReactApexChart
                    options={qmAndAPIStatisticChart.options}
                    series={qmAndAPIStatisticChart.series}
                    type='area'
                    height={350}
                    width='100%'
                  />
                )}
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='card h-450px'>
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-4 mb-1'>
                    Messages Sent vs Credit Usage
                  </span>
                  <span className='text-muted fw-light fs-7'>
                    Message count, credit usage and parts
                  </span>
                </h3>
                <div className='card-toolbar'>
                  <form
                    data-kt-search-element='form'
                    className='me-2 position-relative'
                    autoComplete='off'
                  >
                    <WSSelect
                      value={campTypeCreditCost}
                      onChange={(e: any) => {
                        setCampTypeCreditCost(e.value)
                      }}
                      placeholder='SMS'
                      options={typeOption}
                    />
                  </form>
                </div>
              </div>
              <div className='card-body'>
                {FEMessageSentVsCreditCost?.isLoading ? (
                  <div className='d-flex justify-content-center align-items-center h-350px'>
                    <Spinner />
                  </div>
                ) : (
                  <ReactApexChart
                    options={messageSentVsCreditCostChart.options}
                    series={messageSentVsCreditCostChart.series}
                    type='area'
                    height={350}
                    width='100%'
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ChartDashboard
